
const isTelemetryEnabled = true; // Could be controlled by a setting

export const logEvent = (eventName: string, payload: Record<string, any> = {}) => {
  if (!isTelemetryEnabled) return;

  console.log(
    `%c[TELEMETRY EVENT]%c ${eventName}`,
    'color: #84cc16; font-weight: bold;',
    'color: inherit;',
    payload
  );
};

export const logError = (error: Error, context: Record<string, any> = {}) => {
  if (!isTelemetryEnabled) return;

  console.error(
    `%c[TELEMETRY ERROR]%c ${error.message}`,
    'color: #ef4444; font-weight: bold;',
    'color: inherit;',
    {
      error,
      context,
      stack: error.stack,
    }
  );
};

export const measurePerformance = async <T>(
  metricName: string,
  operation: () => Promise<T>
): Promise<T> => {
  const start = performance.now();
  try {
    const result = await operation();
    const end = performance.now();
    const duration = end - start;

    if (isTelemetryEnabled) {
      console.log(
        `%c[TELEMETRY PERF]%c ${metricName}`,
        'color: #3b82f6; font-weight: bold;',
        'color: inherit;',
        { duration: `${duration.toFixed(2)}ms` }
      );
    }
    return result;
  } catch (error) {
    const end = performance.now();
    const duration = end - start;
     if (isTelemetryEnabled) {
        console.warn(
          `%c[TELEMETRY PERF FAILED]%c ${metricName}`,
          'color: #f97316; font-weight: bold;',
          'color: inherit;',
          { duration: `${duration.toFixed(2)}ms`, error }
        );
      }
    throw error;
  }
};
